import { GroupInfo, customerGroupService } from '../index';

export const processAssignCustomersToGroup = async (
  customerId: number,
  groupInfo: GroupInfo | null | undefined,
) => {
  if (!groupInfo) {
    return;
  }

  const isNewGroup = groupInfo.id === 0;

  if (isNewGroup) {
    const newGroup = await customerGroupService.createGroup(
      groupInfo.name,
      groupInfo.entityId,
    );
    await customerGroupService.assignCustomersToGroup(newGroup.id, [customerId]);
  } else {
    await customerGroupService.assignCustomersToGroup(groupInfo.id, [customerId]);
  }
};
